/* EditorSection.js */

"use strict";
const EditorSectionComponent = require("./EditorSectionComponent");

class EditorSection extends EditorSectionComponent {
    constructor(di, logger, registeredDetails) {
        super(di, logger, registeredDetails);
    }
}

module.exports = EditorSection;
module.exports.$inject = ["$teve.di", "$teve.logger", "$teve.registeredDetails"];
